<template>
  <div
    class="row basic-box user-card"
    @mouseover="toggleButtonVisibility(true)"
    @mouseleave="toggleButtonVisibility(false)"
  >
    <div
      class="place"
      v-if="
        loggedInUserProfile.role === 1 ||
        (loggedInUserProfile.company.privacyLevel > 0 && place < 4)
      "
    >
      {{ place }}.
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 user-image-container">
          <div class="profile image-wrapper">
            <user-image :user="user" class="user-image" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 user-name">
          <router-link class="user-name-link" :to="`/users/${user._id}`">{{
            user.userName
          }}</router-link>
        </div>
      </div>
      <div class="row info-row">
        <transition appear mode="out-in">
          <base-button
            v-if="showButton"
            :text="$t('competition.sendCredit')"
            class="col-12 feedback-button"
            @click="showFeedbackModal(user._id)"
          />
          <div class="col-12" v-else>
            <div class="row data-row">
              <div
                class="col-6"
                v-html="$t('userCard.feedbacks', { feedbacks: user.votes })"
              ></div>
              <div
                class="col-6"
                v-if="
                  loggedInUserProfile.role === 1 ||
                  loggedInUserProfile.company.privacyLevel === 0
                "
                v-html="$t('userCard.MP', { points: user.balance })"
              ></div>
              <div
                class="col-6"
                v-else
                v-html="$t('userCard.won', { won: user.won })"
              ></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '@/components/shared/elements/BaseButton';
import FeedbackModal from '@/components/shared/modals/FeedbackModal';

import UserImage from './UserImage';

export default {
  name: 'UserCard',
  components: {
    UserImage,
    BaseButton,
  },
  data() {
    return {
      showButton: false,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    place: {
      type: Number,
      default: 4,
    },
  },
  methods: {
    toggleButtonVisibility(visibility) {
      if (this.loggedInUserProfile._id !== this.user._id) {
        this.showButton = visibility;
      }
    },
    showFeedbackModal(receiverUserId) {
      this.$eventBus.showModal({
        bind: {
          is: FeedbackModal,
          receiverUserId,
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    rankUrl() {
      if (this.user.won / 3 > 3) {
        return '/static/images/rank_2.svg';
      } else if (this.user.won / 3 >= 2) {
        return '/static/images/rank_1.svg';
      }
      return '/static/images/rank_0.svg';
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  .place {
    position: absolute;
    top: 10%;
    left: 15%;
    opacity: 0.2;
    color: #0a0819;
    font-size: 21px;
  }
  .user-image-container {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    .user-image {
      width: 100px;
      height: 100px;
    }
    .image-wrapper {
      position: relative;
    }
    .rank-image {
      max-height: 30px;
      position: absolute;
      bottom: 3%;
      left: 3%;
      background-color: white;
      border-radius: 50%;
      padding: 5px;
      z-index: 1;
    }
  }
  .user-name-link {
    color: $primary-color;
    &:hover {
      color: $primary-hover-color;
      text-decoration: none;
    }
  }
  .user-name {
    font-size: 16px;
    font-weight: bold;
  }
  .income {
    font-size: 20px;
    font-weight: 100;
    margin: 10px 0;
    color: #22252a;
    .votes {
      color: #76848b;
      font-size: 11px;
    }
  }
  .info-row {
    border-top: 1px solid rgba(53, 54, 61, 0.1);
    padding-top: 20px;
    color: #22252a;
    .col-12,
    .col-6 {
      min-height: 40px;
    }
    .data-row {
      padding: 0;
      font-size: 13px;
      opacity: 0.5;
      .col-6 {
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .feedback-button {
    height: 40px;
  }
}
</style>

